import { render } from "./editOfferInfo.vue?vue&type=template&id=25cc60d8&scoped=true"
import script from "./editOfferInfo.vue?vue&type=script&lang=js"
export * from "./editOfferInfo.vue?vue&type=script&lang=js"

import "./editOfferInfo.vue?vue&type=style&index=0&id=25cc60d8&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cc60d8"]])

export default __exports__